










































import CommonBase from "../CommonBase";
import {Component} from "vue-property-decorator";
import routenames from "../../modules/vRoutedefs";
import {hasIosAppInterface} from "@/modules/utils";

interface Docroute {
    path: string;
    text: string;
}

@Component
export default class Index extends CommonBase {
    rn = routenames;

    userDocroutes: Docroute[] = [
        {path: this.rn.docs.intro.path, text: "Introduksjon"},
        {path: this.rn.docs.regreminder.path, text: this.rn.docs.regreminder.title },
        {path: this.rn.docs.newcard.path, text: this.rn.docs.newcard.title },
        {path: this.rn.docs.notifications.path, text: this.rn.docs.notifications.title },
    ];

    adminDocroutes: Docroute[] = [
      {path: this.rn.docs.adminintro.path, text: this.rn.docs.adminintro.title},
      {path: this.rn.docs.intro.locationsetup.path, text: this.rn.docs.intro.locationsetup.title },
      {path: this.rn.docs.terminal.path, text: this.rn.docs.terminal.title },
      {path: this.rn.docs.roleinfo.path, text: "Info om brukerroller"},
      {path: this.rn.docs.notifications.path, text: this.rn.docs.notifications.title },
      {path: this.rn.docs.hseguidelines.path, text: this.rn.docs.hseguidelines.title },
      {path: this.rn.docs.infectiontrace.path, text: this.rn.docs.infectiontrace.title },
    ];

    get shouldShowAccountInfo() {
        // #AppleCompliance
        // Account init nav link must be hidden when in iOS app to comply with Apple guidelines/avoid app being blocked.
        return !hasIosAppInterface();
    }

    created() {
        if(this.shouldShowAccountInfo) {
            this.adminDocroutes.push({path: this.rn.docs.priceinfo.path, text: this.rn.docs.priceinfo.title});
        }
    }

}
